import { ref, type App } from 'vue'
import {
  type RouteLocationNormalizedGeneric,
  type RouterOptions,
  createRouter as createVueRouter
} from 'vue-router'
import { useRouter } from './composables/useRouter'
import { useUnsavedChanges } from './composables/useUnsavedChanges'
import { useUnsavedChangesDialog } from './composables/useUnsavedChangesDialog'
import { routerServiceKey, type RouterService } from './router-symbol'
import type { GatRouter } from './router-types'

export function createRouterService(): RouterService {
  /** Will stop any route-navigation regardles of any other state.  */
  const forceStopNavigation = ref(false)

  const unsavedChanges = ref(false)

  useUnsavedChanges(unsavedChanges, { preventTabClose: true })

  return {
    forceStopNavigation,
    unsavedChanges
  }
}

export function createRouter(options: RouterOptions): Omit<GatRouter, 'push'> {
  const router = createVueRouter(options)

  function install(app: App) {
    router.install(app)
    // Add the router-service on the plugin-install fn.
    app.provide(routerServiceKey, createRouterService())
  }
  return { ...router, install }
}

/** A route-guard for the router. Will stop the navigation if needed. */
export async function isRouteTransitionAllowed(to: RouteLocationNormalizedGeneric) {
  const router = useRouter()
  const { showUnsavedChangesDialog } = useUnsavedChangesDialog()
  return new Promise<boolean>((resolve) => {
    if (router.unsavedChanges.value) {
      showUnsavedChangesDialog((discardChanges) => {
        resolve(discardChanges === 'yes')
      })
    }
    if (router.forceStopNavigation.value) {
      resolve(false)
    } else {
      resolve(true)
    }
  })
}
